import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { ExitIntentPopup } from '../ui/ExitIntentPopup';
import { CheckCircle2, Lock, Gift, Headphones, Moon, Sparkles } from 'lucide-react';
const BONO_1_IMG = 'https://cdn.magicpatterns.com/uploads/akUF7sZ2bSUsDMZbTAJ3x6/A-Bono1.png';
const BONO_2_IMG = 'https://cdn.magicpatterns.com/uploads/nqaKsf71BXgdKLXQovPgkt/A-Bono2.png';
const BONO_3_IMG = 'https://cdn.magicpatterns.com/uploads/tMCLMhmjaodZLpKJbXEV31/A-Bono3.png';
const ORDER_BUMP_1_IMG = 'https://cdn.magicpatterns.com/uploads/836B2TnBXTUMbaQXm6xkFB/OrderBumo-01.png';
const ORDER_BUMP_2_IMG = 'https://cdn.magicpatterns.com/uploads/21UapiddFfggJN1fXbMcpX/Order_Bump_-_02.png';
const bonuses = [{
  img: BONO_1_IMG,
  title: 'Modo Oficina: Calma Invisible en 2 Minutos',
  value: 'AR$ 15.000'
}, {
  img: BONO_2_IMG,
  title: 'Kit Anti-Rumiación Nocturna: Apagá la Cabeza en 7 Minutos',
  value: 'AR$ 17.000'
}, {
  img: BONO_3_IMG,
  title: 'Mapa de Disparadores: Detectá Tu Ansiedad Antes de Que Explote',
  value: 'AR$ 15.000'
}];
function OrderBumpCheckbox({
  checked,
  onChange
}: {
  checked: boolean;
  onChange: () => void;
}) {
  return <button type="button" onClick={onChange} className={`w-7 h-7 rounded-md border-2 flex items-center justify-center flex-shrink-0 transition-all ${checked ? 'bg-green-500 border-green-500 shadow-md shadow-green-500/30' : 'bg-white/10 border-white/30 hover:border-white/50'}`} aria-label={checked ? 'Quitar del pedido' : 'Agregar al pedido'} data-id="element-266">
      {checked && <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-267">
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-268" />
        </svg>}
    </button>;
}
interface OfferSectionProps {
  isLp1?: boolean;
}
export function OfferSection({
  isLp1
}: OfferSectionProps) {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const basePrice = isLp1 ? 17800 : 8900;
  const bumpPrice = 9000;
  const bumpOriginalPrice = 18000;
  const totalPrice = basePrice + (bump1 ? bumpPrice : 0) + (bump2 ? bumpPrice : 0);
  const totalOriginalValue = 69000 + (bump1 ? bumpOriginalPrice : 0) + (bump2 ? bumpOriginalPrice : 0);
  // Dynamic checkout URL based on order bump selection
  const getCheckoutUrl = () => {
    if (bump1 && bump2) {
      return isLp1 ? 'https://argrutinas.com/cart/42990995275985:1' : 'https://argrutinas.com/cart/42987017732305:1';
    }
    if (bump1) {
      return isLp1 ? 'https://argrutinas.com/cart/42990995210449:1' : 'https://argrutinas.com/cart/42987016716497:1';
    }
    if (bump2) {
      return isLp1 ? 'https://argrutinas.com/cart/42990995177681:1' : 'https://argrutinas.com/cart/42987017830609:1';
    }
    return isLp1 ? 'https://argrutinas.com/cart/42990994227409:1' : 'https://argrutinas.com/cart/42979413688529:1';
  };
  const handleCheckoutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // If no bumps are selected, show popup instead of navigating
    if (!bump1 && !bump2) {
      e.preventDefault();
      setShowPopup(true);
    }
    // Otherwise let the link work normally
  };
  const handlePopupAccept = () => {
    // Redirect to full bundle with 30% discount
    window.location.href = isLp1 ? 'https://argrutinas.com/cart/42990992883921:1' : 'https://argrutinas.com/cart/42987525144785:1';
  };
  const handlePopupDecline = () => {
    // Redirect to main product only
    window.location.href = isLp1 ? 'https://argrutinas.com/cart/42990994227409:1' : 'https://argrutinas.com/cart/42979413688529:1';
  };
  return <section id="oferta" className="bg-slate-900 py-16 sm:py-24 text-white relative overflow-hidden" data-id="element-269">
      <ExitIntentPopup isOpen={showPopup} onClose={() => setShowPopup(false)} onAccept={handlePopupAccept} onDecline={handlePopupDecline} basePrice={basePrice} data-id="element-270" />

      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#4f46e5_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-271"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-272">
        <div className="mx-auto max-w-3xl text-center" data-id="element-273">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6 font-serif" data-id="element-274">
            El Kit de Emergencia que toda argentina debería tener en su celular
          </h2>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-white/20 shadow-2xl mt-8" data-id="element-275">
            {/* Included items */}
            <div className="mb-8" data-id="element-276">
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left" data-id="element-277">
                <li className="flex items-center text-slate-200" data-id="element-278">
                  <CheckCircle2 className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" data-id="element-279" />
                  <span data-id="element-280">Acceso inmediato al PDF</span>
                </li>
                <li className="flex items-center text-slate-200" data-id="element-281">
                  <CheckCircle2 className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" data-id="element-282" />
                  <span data-id="element-283">21 Técnicas probadas</span>
                </li>
                <li className="flex items-center text-slate-200" data-id="element-284">
                  <CheckCircle2 className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" data-id="element-285" />
                  <span data-id="element-286">Audio-Guía de Rescate</span>
                </li>
                <li className="flex items-center text-slate-200" data-id="element-287">
                  <CheckCircle2 className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" data-id="element-288" />
                  <span data-id="element-289">Actualizaciones de por vida</span>
                </li>
              </ul>
            </div>

            {/* Bonuses */}
            <div className="mb-8 pb-8 border-b border-white/10" data-id="element-290">
              <div className="flex items-center justify-center gap-2 mb-6" data-id="element-291">
                <Gift className="w-5 h-5 text-amber-400" data-id="element-292" />
                <p className="text-amber-400 font-semibold text-sm uppercase tracking-wide" data-id="element-293">
                  + 3 Bonos exclusivos incluidos — valor AR$ 47.000
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-294">
                {bonuses.map((bonus, i) => <div key={i} className="bg-white/10 rounded-xl p-4 flex flex-col items-center text-center border border-white/10" data-id="element-295">
                    <img src={bonus.img} alt={bonus.title} className="w-24 h-auto object-contain mb-3 drop-shadow-lg rounded" data-id="element-296" />
                    <span className="text-xs font-bold text-amber-400 uppercase tracking-wide mb-1" data-id="element-297">
                      Bono #{i + 1}
                    </span>
                    <p className="text-white text-xs font-medium leading-snug mb-2" data-id="element-298">
                      {bonus.title}
                    </p>
                    <div className="flex items-center gap-1.5" data-id="element-299">
                      <span className="text-slate-500 line-through text-xs" data-id="element-300">
                        {bonus.value}
                      </span>
                      <span className="text-green-400 text-xs font-bold" data-id="element-301">
                        GRATIS
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Mid CTA — between bonuses and order bumps */}
            <div className="mb-8 pb-8 border-b border-white/10 flex flex-col items-center gap-3" data-id="element-302">
              <p className="text-slate-300 text-sm" data-id="element-303">
                Todo esto por un pago único de
                <span className="text-white font-bold ml-1" data-id="element-304">
                  AR$ {totalPrice.toLocaleString('es-AR')}
                </span>
              </p>
              <Button size="xl" href={getCheckoutUrl()} checkoutValue={totalPrice} onBeforeNavigate={handleCheckoutClick} className="w-full max-w-md bg-blue-600 hover:bg-blue-500 text-white border-none shadow-lg shadow-blue-500/30 text-lg" data-id="element-305">
                QUIERO MI KIT SOS AHORA
              </Button>
              <div className="flex items-center justify-center gap-2 text-xs text-slate-400" data-id="element-306">
                <Lock className="w-3 h-3" data-id="element-307" />
                Pago seguro con Mercado Pago
              </div>
            </div>

            {/* ===== ORDER BUMPS (NOW BEFORE CTA) ===== */}
            <div className="space-y-4 mb-8 pb-8 border-b border-white/10" data-id="element-308">
              {/* Order Bump #1 */}
              <div onClick={() => setBump1(!bump1)} className={`order-bump-shimmer relative rounded-xl border-2 transition-all cursor-pointer text-left overflow-hidden ${bump1 ? 'border-amber-400 bg-amber-400/10 shadow-lg shadow-amber-400/10' : 'border-amber-400/40 bg-amber-400/5 hover:border-amber-400/70'}`} data-id="element-309">
                <div className="bg-amber-400 text-slate-900 text-xs font-bold uppercase tracking-wider px-4 py-1.5 flex items-center gap-2" data-id="element-310">
                  <Sparkles className="w-3.5 h-3.5" data-id="element-311" />
                  Solo por hoy — Disponible únicamente en esta página
                </div>
                <div className="p-5 flex gap-4" data-id="element-312">
                  <OrderBumpCheckbox checked={bump1} onChange={() => setBump1(!bump1)} data-id="element-313" />
                  <div className="flex flex-col sm:flex-row gap-4 flex-1" data-id="element-314">
                    <img src={ORDER_BUMP_1_IMG} alt="SOS Audio-Residencia" className="w-20 h-auto object-contain rounded-lg flex-shrink-0 self-start drop-shadow-md" data-id="element-315" />
                    <div className="flex-1" data-id="element-316">
                      <div className="flex items-center gap-2 mb-1" data-id="element-317">
                        <Headphones className="w-4 h-4 text-amber-400" data-id="element-318" />
                        <span className="text-amber-400 text-xs font-bold uppercase tracking-wide" data-id="element-319">
                          Ahorrá 50%
                        </span>
                      </div>
                      <h4 className="text-white font-bold text-sm sm:text-base mb-1.5 leading-snug" data-id="element-320">
                        Sumá el Entrenamiento de "Re-cableado Neuronal"
                      </h4>
                      <p className="text-slate-300 text-xs leading-relaxed mb-2" data-id="element-321">
                        Mientras el Kit SOS te salva en la crisis, este sistema
                        de audios entrena a tu sistema nervioso todos los días
                        para que los picos de ansiedad dejen de aparecer.
                        Incluye el Audio "La Vacuna Neuronal" + Plan de 21 días.
                      </p>
                      <div className="flex items-center gap-2 flex-wrap" data-id="element-322">
                        <span className={`font-bold text-sm ${bump1 ? 'text-green-400' : 'text-white'}`} data-id="element-323">
                          {bump1 ? 'Agregado' : 'SÍ, QUIERO RE-CABLEAR MI CALMA'}
                        </span>
                        <span className="text-amber-300 font-bold text-sm" data-id="element-324">
                          AR$ 9.000
                        </span>
                        <span className="text-slate-500 line-through text-xs" data-id="element-325">
                          AR$ 18.000
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Order Bump #2 */}
              <div onClick={() => setBump2(!bump2)} className={`order-bump-shimmer order-bump-shimmer-delay relative rounded-xl border-2 transition-all cursor-pointer text-left overflow-hidden ${bump2 ? 'border-indigo-400 bg-indigo-400/10 shadow-lg shadow-indigo-400/10' : 'border-indigo-400/40 bg-indigo-400/5 hover:border-indigo-400/70'}`} data-id="element-326">
                <div className="bg-indigo-400 text-slate-900 text-xs font-bold uppercase tracking-wider px-4 py-1.5 flex items-center gap-2" data-id="element-327">
                  <Moon className="w-3.5 h-3.5" data-id="element-328" />
                  Precio exclusivo para compradoras del Kit SOS
                </div>
                <div className="p-5 flex gap-4" data-id="element-329">
                  <OrderBumpCheckbox checked={bump2} onChange={() => setBump2(!bump2)} data-id="element-330" />
                  <div className="flex flex-col sm:flex-row gap-4 flex-1" data-id="element-331">
                    <img src={ORDER_BUMP_2_IMG} alt="Protocolo de Sueño Profundo" className="w-20 h-auto object-contain rounded-lg flex-shrink-0 self-start drop-shadow-md" data-id="element-332" />
                    <div className="flex-1" data-id="element-333">
                      <div className="flex items-center gap-2 mb-1" data-id="element-334">
                        <Moon className="w-4 h-4 text-indigo-400" data-id="element-335" />
                        <span className="text-indigo-400 text-xs font-bold uppercase tracking-wide" data-id="element-336">
                          Recuperación Nocturna
                        </span>
                      </div>
                      <h4 className="text-white font-bold text-sm sm:text-base mb-1.5 leading-snug" data-id="element-337">
                        ¿Te cuesta "apagar la cabeza" al acostarte? Llevate el
                        Kit de Recuperación Nocturna
                      </h4>
                      <p className="text-slate-300 text-xs leading-relaxed mb-2" data-id="element-338">
                        El 87% de las mujeres con ansiedad sufren rumiación
                        nocturna. Este Protocolo de Sueño Profundo incluye la
                        técnica de Vaciado Mental y el Audio de Inducción
                        Alfa-Delta diseñado para forzar a tu cuerpo al descanso
                        real. Incluye Audio de 20 min + Guía de Higiene del
                        Sueño SOS.
                      </p>
                      <div className="flex items-center gap-2 flex-wrap" data-id="element-339">
                        <span className={`font-bold text-sm ${bump2 ? 'text-green-400' : 'text-white'}`} data-id="element-340">
                          {bump2 ? 'Agregado' : 'SÍ, QUIERO DORMIR BIEN'}
                        </span>
                        <span className="text-indigo-300 font-bold text-sm" data-id="element-341">
                          AR$ 9.000
                        </span>
                        <span className="text-slate-500 line-through text-xs" data-id="element-342">
                          AR$ 18.000
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Price + CTA (NOW AFTER ORDER BUMPS) */}
            <div id="oferta-cta" className="flex flex-col items-center gap-6" data-id="element-343">
              {/* Price card */}
              <div className="w-full max-w-md bg-gradient-to-b from-white/10 to-white/5 rounded-2xl p-6 border border-white/10" data-id="element-344">
                <p className="text-blue-300 font-semibold text-xs uppercase tracking-widest mb-4 text-center" data-id="element-345">
                  Oferta Especial de Lanzamiento
                </p>

                {/* Savings badge */}
                <div className="flex justify-center mb-4" data-id="element-346">
                  <span className="bg-green-500/20 text-green-400 text-xs font-bold px-3 py-1 rounded-full border border-green-500/30" data-id="element-347">
                    Ahorrás AR${' '}
                    {(totalOriginalValue - totalPrice).toLocaleString('es-AR')}{' '}
                    hoy
                  </span>
                </div>

                {/* Price display */}
                <div className="text-center mb-2" data-id="element-348">
                  <span className="text-slate-500 line-through text-lg block mb-1" data-id="element-349">
                    AR$ {totalOriginalValue.toLocaleString('es-AR')}
                  </span>
                  <div className="flex items-end justify-center gap-1" data-id="element-350">
                    <span className="text-blue-300 text-xl font-medium" data-id="element-351">
                      AR$
                    </span>
                    <span className="text-6xl font-bold text-white leading-none tracking-tight" data-id="element-352">
                      {totalPrice.toLocaleString('es-AR')}
                    </span>
                  </div>
                </div>

                {/* Price breakdown */}
                <div className="mt-4 space-y-1.5 text-sm" data-id="element-353">
                  <div className="flex items-center justify-between text-slate-300" data-id="element-354">
                    <span data-id="element-355">Kit SOS Ansiedad + Bonos</span>
                    <span data-id="element-356">AR$ {basePrice.toLocaleString('es-AR')}</span>
                  </div>
                  {bump1 && <div className="flex items-center justify-between text-amber-300" data-id="element-357">
                      <span className="flex items-center gap-1.5" data-id="element-358">
                        <Headphones className="w-3.5 h-3.5" data-id="element-359" />
                        Re-cableado Neuronal
                      </span>
                      <span data-id="element-360">+ AR$ 9.000</span>
                    </div>}
                  {bump2 && <div className="flex items-center justify-between text-indigo-300" data-id="element-361">
                      <span className="flex items-center gap-1.5" data-id="element-362">
                        <Moon className="w-3.5 h-3.5" data-id="element-363" />
                        Sueño Profundo
                      </span>
                      <span data-id="element-364">+ AR$ 9.000</span>
                    </div>}
                  <div className="border-t border-white/10 pt-2 mt-2 flex items-center justify-between text-white font-bold" data-id="element-365">
                    <span data-id="element-366">Total hoy</span>
                    <span className="text-lg" data-id="element-367">
                      AR$ {totalPrice.toLocaleString('es-AR')}
                    </span>
                  </div>
                </div>

                <p className="text-slate-400 mt-3 text-xs text-center" data-id="element-368">
                  {bump1 || bump2 ? 'Pago único — Todo incluido' : 'Menos de lo que gastás en un delivery'}
                </p>
              </div>

              {/* CTA Button */}
              <div className="w-full max-w-md" data-id="element-369">
                <Button size="xl" href={getCheckoutUrl()} checkoutValue={totalPrice} onBeforeNavigate={handleCheckoutClick} className="w-full bg-blue-600 hover:bg-blue-500 text-white border-none shadow-xl shadow-blue-500/30 text-lg" data-id="element-370">
                  QUIERO MI KIT SOS AHORA
                </Button>
                <div className="flex items-center justify-center gap-4 mt-4 text-xs text-slate-400" data-id="element-371">
                  <span className="flex items-center gap-1.5" data-id="element-372">
                    <Lock className="w-3 h-3" data-id="element-373" />
                    Pago seguro
                  </span>
                  <span className="text-slate-600" data-id="element-374">·</span>
                  <span data-id="element-375">Acceso inmediato</span>
                  <span className="text-slate-600" data-id="element-376">·</span>
                  <span data-id="element-377">Garantía 7 días</span>
                </div>
              </div>
            </div>
          </div>

          <p className="mt-8 text-slate-400 text-sm" data-id="element-378">
            Llevate el botiquín emocional que vas a tener para siempre en tu
            celular.
          </p>
        </div>
      </div>
    </section>;
}